<!-- スマイル移行後の新コンポネント -->

<template>
  <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" style="min-width: 500px;">

    <!-- 清掃員の場合 -->
    <div class="font-bold text-xl text-gray-600 mb-3 col-span-full">
      清掃員
      <span class="pl-5 text-red-700 text-sm">「採用」の場合、タスク完了時に雇い入れタスクが自動登録されます</span>
    </div>

    <div class="sm:col-span-full">
      <SelectionButton2
        name="acceptanceSelections"
        v-model="requestPost.interviewsResult"
        :item ="acceptanceSelections"
        :multiSelect="false"
        :disabled="referenceMode||requestPost.interviewsResNotEditable"
        @change="setTitle('採否')"
      />
      <div v-if="requestPost.resultSetDate" class="mt-1 text-xs font-bold text-purple-500 w-fit ml-auto">採否決定日： {{ requestPost.resultSetDate }}</div>
    </div>

    <!-- 清掃員 面接 -->
    <div class="col-span-full">
      <div class="sm:col-span-full">
        <WmsDateInput
          name="interviewsHireDate"
          caption="入社日"
          v-model="requestPost.interviewsHireDate"
          :clearable="true"
          :required="isAdopt"
          :error="!requireValidateStr('interviewsHireDate', '入社日').result"
          :errorMessage="requireValidateStr('interviewsHireDate', '入社日').message"
          @change="requestPost.startDateWork=requestPost.interviewsHireDate"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-3 mb-7">
        <WmsTextInput
          name="interviewsName"
          caption="氏名"
          v-model="requestPost.interviewsName"
          :disabled="referenceMode"
          @change="setTitle()"
          :required="true"
          :error="!requireValidateStr('interviewsName', '氏名').result"
          :errorMessage="requireValidateStr('interviewsName', '氏名').message"
        />
      </div>

      <!-- 遷移ボタン -->
      <div v-if="!requestPost._id" class="text-xs font-bold text-red-700 mb-1">一度保存しなければ遷移できません</div>
      <div v-else-if="!isAdopt" class="text-xs font-bold text-red-700 mb-1">入力・一時保存はできますが、申請は採否を「採用」にして保存してからできます</div>
      <PrimaryButton class="" :buttonContents="'要'" text="雇用指示へ登録" :disabled="!requestPost._id" @click="toAkbsEmployment()">
        <Icon slot="before" iconName="ClipboardList" iconType="solid" :strokeWidth="2" class="h-5 w-5 mr-1.5" />
      </PrimaryButton>

      <div class="sm:col-span-full mt-7">
        <label for="interviewsMedium" class="block text-xs font-bold text-gray-700 relative">
          募集媒体
          <span class="text-blue-700 cursor-pointer px-3 ml-5 py-1 text-xs underline" @click="openMediaModal=true">ドロップダウンに該当するものがない時はこちらをクリック</span>
        </label>
        <div class="mt-1 flex relative">
          <select
            name="interviewsMedium"
            v-model="requestPost.interviewsMedium"
            class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed':'bg-white'"
            :disabled="referenceMode"
          >
            <option
              v-for="list in mediaList" :key='list._id'
              :value="list.name"
              class="bg-white">
              {{ list.name }}
            </option>
          </select>
        </div>
      </div>

      <InputGroupLabel
        name="categoryTitle"
        caption=""
        class="mt-10"
      />

      <div class="sm:col-span-full mt-3">

        <SelectionButton2
          name="interviewsMaterial"
          caption="必要な書類"
          v-model="requestPost.interviewsMaterial"
          :item="materialSelections"
          :multiSelect="true"
          :disabled="referenceMode"
          :required="isAdopt"
          :error="!requireValidateArr('interviewsMaterial', '必要な書類').result"
          :errorMessage="requireValidateArr('interviewsMaterial', '必要な書類').message"
          class="mt-3"
        />
      </div>

      <div class="sm:col-span-full mt-7">
        <WmsTextInput
          name="interviewsInterviewNotes"
          caption="面接管記入欄（評価・寸評）"
          v-model="requestPost.interviewsInterviewNotes"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700">
          認知症テスト結果
        </label>
        <div class="mt-1">
          <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
            <WmsAttachment
              name="interviewsCognitiveRes"
              style="max-width: none!important;"
              :value="requestPost.interviewsCognitiveRes"
              :disabled="referenceMode"
              @change="attachmentChange('interviewsCognitiveRes', $event)"
            />
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（履歴書）<span v-if="isAdopt" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </label>
        <div class="mt-1">
          <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
            <WmsAttachment
              name="interviewsDocument"
              style="max-width: none!important;"
              :value="requestPost.interviewsDocument"
              :disabled="referenceMode"
              @change="attachmentChange('interviewsDocument', $event)"
              :errorMessage="requireValidateAttach('interviewsDocument', '履歴書').message"
            />
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile"
              style="max-width: none!important;"
              :value="requestPost.commonFile"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 追加ボタン -->
          <div class="addButton-contents ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addCommonFile()">
              <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div  v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(2)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile2"
              style="max-width: none!important;"
              :value="requestPost.commonFile2"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile2', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(2)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(3)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile3"
              style="max-width: none!important;"
              :value="requestPost.commonFile3"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile3', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(3)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(4)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile4"
              style="max-width: none!important;"
              :value="requestPost.commonFile4"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile4', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(4)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(5)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile5"
              style="max-width: none!important;"
              :value="requestPost.commonFile5"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile5', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(5)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="employmentRemarks"
          caption="連絡事項"
          v-model="requestPost.employmentRemarks"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>

      <!-- *******************質問******************* -->
      <InputGroupLabel
        name="categoryTitle"
        caption="確認事項"
        class="mt-10"
      />

      <div class="sm:col-span-full mt-5">
        <template v-for="item in checkItems">
          <SelectionOneValue
            v-if="item.type === 'select'"
            :key="item.name"
            :caption="item.caption"
            v-model="requestPost[item.name]"
            :list="yesnoSelections"
            :disabled="referenceMode"
            :class="item.class"
          ></SelectionOneValue>

          <WmsTextInput
            v-else-if="item.type === 'text'"
            :key="item.name + 't'"
            :name="item.name"
            :caption="item.caption"
            v-model="requestPost[item.name]"
            :disabled="referenceMode"
            :class="item.class"
          />

          <WmsDateInput
            v-else-if="item.type === 'date'"
            :key="item.name + 'd'"
            :name="item.name"
            :caption="item.caption"
            v-model="requestPost[item.name]"
            :clearable="true"
            :min="minDay"
            :disabled="referenceMode"
            :class="item.class"
          />

          <NumericTextInput2
            v-else-if="item.type === 'number'"
            :key="item.name + 'n'"
            :name="item.name"
            :caption="item.caption"
            :maxLenght="item.maxLength"
            v-model="requestPost[item.name]"
            :disabled="referenceMode"
            :class="item.class"
          />
        </template>
      </div>
    </div>

    <div class="text-transparent text-xs">{{reload}}</div>

    <!-- 募集媒体モーダル -->
    <EmploymentMediaModal
      v-model="openMediaModal"
      :open="openMediaModal"
      @close="closeMediaModal()"
    />
  </div>
</template>

<script>
  import Icon from '@components/Icon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import moment from 'moment'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionOneValue from '@components/SelectionOneValue.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import InputGroupLabel from '../components/InputGroupLabel.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import EmploymentMediaModal from '../components/EmploymentMediaModal.vue'
  import * as employmentMediaManager from '@managers/employmentMediaManager'
  import * as dialogs from '@libs/dialogs'
  import * as constants from '@libs/constants'
  import * as helper from '@libs/helper'
  import * as backend from '@libs/backend'

  const ACCEPTANCE_SELECTIONS = [
    {
      value: '採用',
      text: '採用'
    },
    {
      value: '不採用',
      text: '不採用'
    }
  ]

  const YESNO_SELECTIONS = [
    {
      id: 'はい',
      name: 'はい'
    },
    {
      id: 'いいえ',
      name: 'いいえ'
    }
  ]

  // 確認事項
  const CHECK_ITEMS = [
    {
      type: 'select',
      name: 'interviewsOtherPropertyConsultation',
      caption: 'ご応募の物件ではなく、別の物件の相談は可能ですか？',
      class: ''
    },
    {
      type: 'text',
      name: 'interviewsDesiredDateAndTime',
      caption: 'その際の希望日数時間',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsSubstituteWork',
      caption: '代行勤務は可能ですか？',
      class: 'mt-2'
    },
    {
      type: 'text',
      name: 'interviewsPossibleDateAndTime',
      caption: '代行 可能日数・時間',
      class: 'mt-2'
    },
    {
      type: 'date',
      name: 'interviewsEarliestStartDate',
      caption: '最短の勤務開始可能日',
      class: 'mt-7'
    },
    {
      type: 'select',
      name: 'interviewsSmoking',
      caption: 'タバコは吸われますか？',
      class: 'mt-7'
    },
    {
      type: 'select',
      name: 'interviewsSmokingBan',
      caption: 'はいの場合は、通勤経路、就業時間中、職場内での禁煙出来ますか？',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsAlcoholConsumption',
      caption: '飲酒はされますか？',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsPersonalHygiene',
      caption: '身だしなみ、髪、爪等は清潔に保てますか。',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsTransferAfterProbation',
      caption: '試用期間終了後の異動可否',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsMonthlyLeaveForFamily',
      caption: 'ご家庭等の都合で月1回以上お休みしなければならないことがありますか？',
      class: 'mt-2'
    },
    {
      type: 'text',
      name: 'interviewsReasonForLeave',
      caption: 'はいの場合理由',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsResignationNotice',
      caption: '止むを得ない理由により退職する際は、退職希望日の1ヶ月前に申し入れできますか？',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsContactBeforeLeave',
      caption: 'お休みの場合は最低でも2週間前までに必ず会社に連絡ができますか？(急病や不幸は除きます。)',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsCleaningExperience',
      caption: '清掃に関する仕事の経験はありますか？',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsChronicDisease',
      caption: '持病はありますか？',
      class: 'mt-2'
    },
    {
      type: 'text',
      name: 'interviewsApplicableDiseases',
      caption: '持病がある場合、記載ください。',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsCurrentMedication',
      caption: '現在服用のお薬はありますか？',
      class: 'mt-2'
    },
    {
      type: 'text',
      name: 'interviewsMedicationDetails',
      caption: 'はいの方はお薬の種類を記載ください。',
      class: 'mt-2'
    },
    {
      type: 'select',
      name: 'interviewsHealthConcerns',
      caption: '上記ご病気以外において体調で気になる部分はありますか？',
      class: 'mt-2'
    },
    {
      type: 'text',
      name: 'interviewsHealthConcernsDetails',
      caption: 'はいの場合',
      class: 'mt-2'
    },
    {
      type: 'number',
      name: 'interviewsCognitiveTestScore',
      caption: '認知テスト点数',
      maxLength: '3',
      class: 'mt-2'
    }
  ]

  export default {
    components: {
      Icon,
      PrimaryButton,
      WmsDateInput,
      WmsTextInput,
      InputGroupLabel,
      NumericTextInput2,
      SelectionOneValue,
      SelectionButton2,
      WmsAttachment,
      EmploymentMediaModal,
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isTaskRequestMode: {
        type: Boolean,
        default: false
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      // 面接権限ありor人事部
      isAuth: {
        type: Boolean,
        default: false
      },
      departmentLists: {
        type: Array
      },
    },

    data() {
      return {
        yesnoSelections: YESNO_SELECTIONS,
        acceptanceSelections: ACCEPTANCE_SELECTIONS,
        materialSelections: constants.MATERIAL_SELECTIONS,
        checkItems: CHECK_ITEMS,
        loading: false,
        reload: 0,
        // 募集媒体リスト
        mediaList: [],
        // 募集媒体リストモーダルopen
        openMediaModal: false,
        // チャットワークルームIDマスタモーダルopen
        openChatRoomId: false,
        // 選択できる最小日
        minDay: moment().format('YYYY-MM-DD'),
        mailTo: '',
      }
    },

    computed: {
      /**
       * DC採用の場合
       */
      isAdopt() {
        if (this.requestPost.interviewsResult && this.requestPost.interviewsResult[0] && this.requestPost.interviewsResult[0] == '採用') {
          return true
        } else {
          return false
        }
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item, name)=> {
          // 入社日は、採用の場合のみ
          if (['interviewsHireDate'].includes(item)) {
            if (this.isAdopt) {
              if (!this.requestPost[item] && this.requestPost[item] !== 0) {
                return {
                  result: false,
                  message: `採用の場合、${name}は必須項目です。${name}を入力してください。`
                }
              }
            }
          } else if (!this.requestPost[item] && this.requestPost[item] !== 0) {
            return {
              result: false,
              message: `${name}は必須項目です。${name}を入力してください。`
            }
          }
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item, name)=> {
          let required = true
          let saiyo = ''
          // 必要な書類は採用の場合のみ
          if (['interviewsMaterial'].includes(item)) {
            if (this.isAdopt) {
              required = true
              saiyo = '採用の場合、'
            } else {
              required = false
            }
          }

          if (required && (!this.requestPost[item] || !this.requestPost[item].length)) {
            return {
              result: false,
              message: `${saiyo + name}は必須項目です。${name}を選択してください。`
            }
          } else {
            return {
              result: true,
              message: ''
            }
          }
        }
      },

      /**
       * 必須項目入力チェック（添付ファイル）
       */
      requireValidateAttach() {
        return (item, name)=> {
          // 採用の場合に限る
          if (this.isAdopt && (!this.requestPost[item] || (!this.requestPost[item].content && !this.requestPost[item].url))) {
            return {
              result: false,
              message: `${name}は必須項目です。${name}を添付してください。`
            }
          } else {
            return {
              result: true,
              message: ''
            }
          }
        }
      },
    },

    watch: {
      loading(val) {
        if (val) {
          this.$emit('loadingStart')
        } else {
          this.$emit('loadingEnd')
        }
      }
    },

    async created() {
      // 募集媒体リスト取得
      this.getMediaList()
    },

    methods: {
      /**
      * タイトルをセット
      */
      setTitle() {
        // 採否結果＋名前＋物件名
        let t = {
          interviewsResult: this.requestPost.interviewsResult,
          name: this.requestPost.interviewsName,
          site: this.requestPost.interviewsAppliedWorkLocationAddress,
          interviewsRegularStaff: false,
          newGrad: false
        }
        this.$emit('get-title', t)
      },

      /**
      * 添付ファイル
      */
      attachmentChange(targetAttachmentName, attachmentInfo) {
        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
      * 必須項目入力チェック
      */
      async validation() {

        // DCの必須項目（文字列、配列、オブジェクト）
        const dcVal = [
          { item: 'interviewsHireDate', name: '入社日' }
          ,{ item: 'interviewsName', name: '氏名' }
          ,{ item: 'interviewsMaterial', name: '必要な書類' }
        ]

        for (let i = 0; i < dcVal.length; i++) {
          const s = dcVal[i]
          let res = {}

          if (Array.isArray(this.requestPost[s.item])) {
            res = this.requireValidateArr(s.item, s.name)
          } else {
            res = this.requireValidateStr(s.item, s.name)
          }

          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // 添付
        const valArr = [
          { item: 'interviewsDocument', name: '履歴書' }
        ]
        for (let i = 0; i < valArr.length; i++) {
          const a = valArr[i]
          let res = {}
          res = this.requireValidateAttach(a.item, a.name)
          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // 清掃員マスタに同姓同名がいないか（退職済みなら「再入社」から登録するよう促す）
        if (!await this.checkSameName()) {
          return false
        }

        return true
      },

      /**
       * 清掃員マスタに同姓同名の清掃員がいないか確認する（退職した人も対象）
       * API: akbsTable/checkName
       * ・退職済み（退職日あり）の同姓同名がいれば、同じ人なら面接ではなく「雇い入れ（清掃員）」の「再入社」から登録するよう促す
       * ・在職中の同姓同名がいれば、二重登録でないか確認する
       * ・「別人として保存」を選んだ氏名は requestPost に控え、同じ氏名のまま保存し直すときは聞かない
       * ・確認の通信に失敗しても保存は止めない
       * @returns {Promise<Boolean>} 保存を続けてよければ true
       */
      async checkSameName() {
        const name = (this.requestPost.interviewsName || '').trim()
        if (!name || this.requestPost.interviewsSameNameConfirmed === name) {
          return true
        }

        let rows = []
        try {
          const res = await backend.searchData('akbsTable/checkName', { name, tel: '', moblie: '' })
          rows = (res && res.data && res.data.data) || []
        } catch (e) {
          console.log(e)
          return true
        }
        if (!rows.length) {
          return true
        }

        const staffLine = (r) => `・清掃員コード ${r.staffCode}${r.banned ? '／' + r.banned : ''}`
        const retired = rows.filter(r => r.resignation)
        const active = rows.filter(r => !r.resignation)
        const parts = []

        if (retired.length) {
          const lines = retired.map(r => `${staffLine(r)}\n  退職日：${r.resignation}／退職理由：${r.retireReason || '－'}`)
          parts.push(`清掃員マスタに、退職済みの「${name}」さんがいます。\n${lines.join('\n')}\n\n同じ人なら、この面接は保存せず、「雇い入れ（清掃員）」の「再入社」から登録してください。`)
        }
        if (active.length) {
          const lines = active.map(r => staffLine(r))
          parts.push(`清掃員マスタに、在職中の「${name}」さんがいます。\n${lines.join('\n')}\n\n同じ人なら、この面接は保存せず、「雇い入れ（清掃員）」から進めてください。`)
        }

        const title = retired.length ? '退職済みの清掃員と同姓同名です' : '在職中の清掃員と同姓同名です'
        const result = await dialogs.showConfirmDialog(title, `${parts.join('\n\n')}\n\n別人なら「別人として保存」で続けられます。`, '別人として保存', '保存しない')
        if (result !== 'YES') {
          return false
        }
        // 別人と決めた氏名を控える（メインタスクと一緒に保存される）
        this.requestPost.interviewsSameNameConfirmed = name
        return true
      },

      /**
      * 添付資料（紹介状・他）追加ボタン
      */
      async addCommonFile() {
        const files = this.requestPost.interviewsCommonFileList
        if (files && files.length <= 4) {
          for (let i = 1; i <= 5; i++) {
            if (!files.includes(i)) {
              files.push(i)
              this.reload++
              return
            }
          }
        } else if (files.length >= 5) {
          await dialogs.showInfoDialog('添付資料（紹介状・他）は5つまでです', 'これ以上、添付資料（紹介状・他）は増やせません。')
        }
      },

      /**
      * 添付資料（紹介状・他）削除ボタン
      * @param i 添付資料（紹介状・他）番号
      */
      removeCommonFile(i) {
        const files = this.requestPost.interviewsCommonFileList
        const res = files.filter((f) => {
          return i != f
        })
        this.requestPost.interviewsCommonFileList = res
      },

      /**
        * 募集媒体リスト取得
        */
      async getMediaList() {
        this.mediaList = await employmentMediaManager.getMediaList(this)
      },

      /**
        * 募集媒体モダール閉じる
        */
      closeMediaModal() {
        this.openMediaModal = false
        this.getMediaList()
      },

      /**
       * 雇い入れ➡AKBS画面に遷移
       */
      toAkbsEmployment() {
        this.$router.push({
          name: 'AkbsInputForm',
          query: { requestPostId: this.requestPost._id, from: 'interviews' },
          // 清掃員名・入社日
          params: { name: this.requestPost.interviewsName, dateHire: this.requestPost.interviewsHireDate }
        })
      }
    }
  }
</script>

<style scoped>
  #diseaseDiv >>> button[type=button] {
    width: 19.8% !important;
  }

  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

  #interviewsAppliedWorkDays >>> button[type=button] {
    width: 12% !important;
  }

  .send-date >>> input {
    text-align: center !important;
  }

  /* 入力欄を自動調整 */
  textarea {
    field-sizing: content !important;
  }

  .multiselect >>> .multiselect__tags {
    padding-right: 22px !important;
  }

  .multiselect >>> .multiselect__select {
    padding-right: 4px !important;
  }
</style>